export default __webpack_public_path__ + "static/media/FrutigerLTW02-65Bold.62dbdff6.woff";